import React, { useState, useEffect } from "react";
import { FaDownload } from "react-icons/fa6";
import { Spinner as SpinnerBoot } from "react-bootstrap";
import { useSelector } from "react-redux";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import Select from "react-select";

function Prescripition() {
  const [isLoading, setIsLoading] = useState(false);
  const [prescriptionData, setPrescriptionData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [uniqueDoctors, setUniqueDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState({ value: "all", label: "All" });
  const patientLogin = useSelector((state) => state.patient.patientLogin);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData("healthcare/prescriptions");
  }, []);

  const fetchData = async (endpoint) => {
    setIsLoading(true);
    try {
      const res = await SendPostRequest(endpoint, {
        user_id: patientLogin?.contact_num,
      });

      if (res?.data && Array.isArray(res.data)) {
        const doctors = [...new Set(res.data.map((doc) => doc?.doctor))];
        const options = [{ value: "all", label: "All" }, ...doctors.map((d) => ({ value: d, label: d }))];
        setUniqueDoctors(options);
        setPrescriptionData(res.data);
        setFilteredData(res.data);
      } else {
        setUniqueDoctors([{ value: "all", label: "All" }]);
        setPrescriptionData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setUniqueDoctors([{ value: "all", label: "All" }]);
      setPrescriptionData([]);
      setFilteredData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReportDownload = (reportUrl) => {
    window.open(reportUrl, "_blank");
  };

  useEffect(() => {
    if (selectedDoctor.value === "all") {
      setFilteredData(prescriptionData);
    } else {
      setFilteredData(prescriptionData.filter((doc) => doc?.doctor === selectedDoctor.value));
    }
  }, [selectedDoctor, prescriptionData]);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #ced4da",
      borderRadius: "0.25rem",
      minHeight: "40px",
      fontSize: "0.875rem",
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: "0.875rem",
    }),
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="Prescripition">
      <div className="prescripition-heading-wrapper d-flex justify-content-between align-items-center flex-wrap">
        <h3>Prescriptions</h3>
        <div className="prescripition-button-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", flexWrap: "wrap" }}>
          <button
            className="login"
            onClick={() => fetchData("healthcare/prescriptions")}
          >
            OPD
          </button>
          <button
            className="login"
            style={{ marginLeft: isMobile ? "20px" : "20px" }}
            onClick={() => fetchData("healthcare/emr_prescriptions")}
          >
            EMERGENCY
          </button>

          <div >
            {isLoading ? (
              <SpinnerBoot style={{ marginLeft: "20px" }} />
            ) : (
              <div style={{ minWidth: "250px", marginLeft: isMobile ? "0px" : "20px", marginTop: isMobile ? "12px" : "" }}>
                <Select
                  options={uniqueDoctors}
                  value={selectedDoctor}
                  onChange={(option) => setSelectedDoctor(option)}
                  styles={customStyles}
                  isSearchable
                  placeholder="Select Doctor..."
                />
              </div>
            )}
          </div>
        </div>
      </div>


      {isLoading ? (
        <div
          style={{ marginBottom: "60px" }}
          className="d-flex align-items-center justify-content-center"
        >
          <Spinner />
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table mt-2">
            <thead className="thead-light">
              <tr>
                <th scope="col">SR.NO</th>
                <th scope="col">DOCTOR</th>
                <th scope="col">SHIFT</th>
                <th scope="col">DATE</th>
                <th scope="col">STATUS</th>
                <th scope="col">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {filteredData?.length === 0 ? (
                <tr>
                  <td colSpan="6">
                    <div className="prescription-rapper">No Record Available</div>
                  </td>
                </tr>
              ) : (
                filteredData?.map((prescription, index) => (
                  <tr key={prescription?.PrescriptionUID}>
                    <td>{index + 1}</td>
                    <td>{prescription?.doctor || "--"}</td>
                    <td >{prescription?.shift || "--"}</td>
                    <td >
                      {prescription?.approved_date || "--"}
                    </td>
                    <td >{prescription?.arrival_status || "--"}</td>
                    {/* <td style={{ width: "500px" }}>{prescription?.complaint || "--"}</td>
                    <td style={{ width: "500px" }}>{prescription?.notes || "--"}</td> */}
                    <td>
                      <button
                        className="download"
                        onClick={() => handleReportDownload(prescription?.prescription_link)}
                      >
                        <FaDownload />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Prescripition;
